<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left:20px">
        <FormItem label="展示数据">
          <Tag
            :checked="showColumnTitleArray.indexOf(item.title) > -1"
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
          >{{item.title}}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>
    <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>详细状态</span>
      </p>
      <table>
        <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr>
      </table>
      <div slot="footer"></div>
    </Modal>
    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <div class="query-c">
        <Select
          clearable
          v-model="searchObject.meterType"
          style="width:10%;margin-right: 5px"
          placeholder="选择表具类型"
        >
          <!-- <Option value="水表" key="水表">水表</Option> -->
          <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option>
        </Select>
        <!-- <Input v-model="searchObject.userAccount" placeholder="输入用户账号(模糊查询)" style="width: 200px;margin-right: 5px" /> -->
        <!-- <Input v-model="searchObject.userName" placeholder="输入客户名称(模糊查询)" style="width: 150px;margin-right: 5px" /> -->
        <Select
          clearable
          filterable
          v-model="searchObject.userAccount"
          style="width:20%;margin-right: 5px"
          placeholder="选择客户"
        >
          <!-- <Option v-for="item in userList" :value="item.userName" :key="item.userName">{{item.userName}}</Option> -->
          <Option
            v-for="item in userList"
            v-if="getMeterType(item.userMeterType).indexOf(searchObject.meterType) > -1 "
            :value="item.userAccount"
            :key="item.userAccount"
          >
            {{
            item.userName
            }}
          </Option>
        </Select>
        <DatePicker
            :options="optionsDisabled"
            v-model="searchObject.meterBirth"
            type="date"
            placeholder="出厂日期"
            style="width: 12%;margin-left:5px"
        ></DatePicker>
        <Select
          clearable
          filterable
          placeholder="选择表具口径"
          v-model="searchObject.meterCaliber"
          style="width:10%;margin-left:5px"
        >
          <Option v-for="item in caliberEnum" :value="item" :key="item">{{ item }}</Option>
        </Select>
        <Input
          v-model="searchObject.meterAddress"
          placeholder="输入表具地址(模糊查询)"
          style="width: 15%;margin-left: 5px"
        />

        <Button style="margin-left:10px" type="primary" icon="ios-search" @click="showPage">查询</Button>

        <Button
          type="primary"
          @click="isShowSetModal = true"
          style="float:right;margin-left:5px"
        >显示项设置</Button>
        <Button type="primary" @click="exportData" style="float:right;margin-left:5px">导出数据</Button>
      </div>
      <br />
      <Table
        ref="dataTable"
        size="small"
        :height="tableHeight"
        border
        stripe
        :columns="columns"
        :data="data"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="showState(row)"
          >查看设备状态</Button>
        </template>-->
      </Table>
      <br />
      <!-- <Page :total="100" show-sizer show-elevator /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "lastmessage",
  data() {
    var that = this;
    return {
      dateArray: [],
      optionsDisabled: {
          disabledDate (date) {
              return date && that.dateArray.indexOf(global.dateFtt("yyyy-MM-dd", date)) == -1;
          }
      },
      pageName: "lastmessage",
      meterTypeEnum: global.meterType(),
      showColumnTitleArray: [],
      columnsbackup: [
        // {
        //     title: '通信数据',
        //     type: 'expand',
        //     width: 100,
        //     render: (h, params) => {
        //         return h("div", [
        //         h(
        //             "span", {
        //             props: {},
        //             style: {},
        //             on: {}
        //             },
        //             "通信数据帧：   " + (params.row.messageContent == undefined?"无":JSON.parse(params.row.messageContent).data)
        //         )
        //         ]);
        //     }
        // },
        {
          title: "序号",
          type: "index",
          width: 100,
          align: "center"
        },
        {
          title: "用户账号",
          key: "userAccount",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "用户名称",
          key: "userName",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "表具地址",
          width: 150,
          key: "messageAddress"
        },
        {
          title: "口径",
          resizable: true,
          width: 100,
          key: "meterCaliber"
        },
        {
          title: "上报时间",
          width: 180,
          key: "上报时间"
        },
        {
          title: "上报总次数",
          width: 180,
          key: "上报总次数"
        },
        {
          title: "上报成功次数",
          width: 180,
          key: "上报成功次数"
        },
        {
          title: "抄表总次数",
          width: 180,
          key: "抄表总次数"
        },
        {
          title: "抄表成功次数",
          width: 180,
          key: "抄表成功次数"
        },
        {
          title: "电池电压",
          width: 100,
          key: "电池电压"
        },
        {
          title: "信号强度",
          width: 100,
          key: "信号强度"
        },
        {
          title: "设备状态",
          width: 100,
          key: "设备状态"
        },
        {
          title: "通信数据",
          width: 1500,
          key: "通信数据"
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      tableHeight: "200",
      addressfield1: "",
      addressfield2: "",
      addressfield3: "",
      addressfield4: "",
      addressfield5: "",
      caliberEnum: [],
      searchObject: {
        meterType: "水表"
      },
      // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
      //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
      //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
      //   "00000018005405", "00000018005456", "00000018005462"
      // ],
      meterArray: [],
      meterArray1: [
        "00000018003155",
        "00000018004361",
        "00000018004457",
        "00000018004523",
        "00000018004798",
        "00000018005064",
        "00000018005332",
        "00000018005401",
        "00000018005456",
        "00000018005462",
        "11110000000000"
      ],
      meterArray2: ["00000018005405", "00000018004345", "00000018004799"],
      addressObject: {},
      stateContrast: global.stateContrast,
      meterAddress: "",
      stateArray: {},
      isShowStateModal: false,
      isShowSetModal: false,
      columns: [
        // {
        //     title: '通信数据',
        //     type: 'expand',
        //     width: 100,
        //     render: (h, params) => {
        //       return h("div", [
        //         h(
        //           "span", {
        //             props: {},
        //             style: {},
        //             on: {}
        //           },
        //           "通信数据帧：   " + (params.row.messageContent == undefined?"无":JSON.parse(params.row.messageContent).data)
        //         )
        //       ]);
        //     }
        // },
        {
          title: "序号",
          type: "index",
          width: 100,
          align: "center"
        },
        {
          title: "用户账号",
          key: "userAccount",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "用户名称",
          key: "userName",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "表具地址",
          width: 150,
          key: "messageAddress"
        },
        {
          title: "口径",
          resizable: true,
          width: 100,
          key: "meterCaliber"
        },
        {
          title: "上报时间",
          width: 180,
          key: "上报时间"
        },
        {
          title: "上报总次数",
          width: 180,
          key: "上报总次数"
        },
        {
          title: "上报成功次数",
          width: 180,
          key: "上报成功次数"
        },
        {
          title: "抄表总次数",
          width: 180,
          key: "抄表总次数"
        },
        {
          title: "抄表成功次数",
          width: 180,
          key: "抄表成功次数"
        },
        {
          title: "电池电压",
          width: 100,
          key: "电池电压"
        },
        {
          title: "信号强度",
          width: 100,
          key: "信号强度"
        },
        {
          title: "设备状态",
          width: 100,
          key: "设备状态"
        },
        {
          title: "通信数据",
          width: 1500,
          key: "通信数据"
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      data: [],
      userList: []
    };
  },
  methods: {
    exportData() {
      this.$refs.dataTable.exportCsv({
        filename: "表具最新数据"
      });
    },
    getMeterType(type) {
      return global.getMeterType(type);
    },
    getUserList() {
      var that = this;
      that.$axios
        .post("/api/user/getUserList", {})
        .then(function(res) {
          console.log(res);
          that.userList = res.body;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getMeterCaliberEnum() {
      var that = this;
      that.$axios
        .post("/api/meter/getMeterCaliberEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.caliberEnum = data.body;
          that.caliberEnum.sort(function(a, b) {
            return (
              parseInt(a.replace("DN", "")) - parseInt(b.replace("DN", ""))
            );
          });
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {
          // that.showPage();
        });
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;

      if (
        localStorage.getItem(
          this.pageName + localStorage.getItem("userAccount")
        ) != undefined
      ) {
        this.showColumnTitleArray = JSON.parse(
          localStorage.getItem(
            this.pageName + localStorage.getItem("userAccount")
          )
        );
        var showArray = [];
        for (let i = 0; i < this.columnsbackup.length; i++) {
          let currentObject = this.columnsbackup[i];
          if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
            showArray.push(currentObject);
          }
        }

        this.columns = showArray;
      }
    },
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressObject = data.body;
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    parseDate(str) {
      var year = str.substr(0, 4);
      var month = str.substr(4, 2);
      var day = str.substr(6, 2);
      var hour = str.substr(8, 2);
      var minute = str.substr(10, 2);
      var second = str.substr(12, 2);
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    onClickSearch() {
      this.showPage();
    },
    showState(row) {
      this.isShowStateModal = true;
      this.stateArray = JSON.parse(row.messageContent).decode.state;
    },
    showStateStr(row) {
      let stateArray = JSON.parse(row.messageContent).decode?(JSON.parse(row.messageContent).decode.state?JSON.parse(row.messageContent).decode.state:{}):{};
      let that = this;
      let stateStr = "";
      let meterType = row.meterType;
      Object.keys(stateArray).forEach(function(key) {
        if (
          (meterType == "流量计" ||
            meterType == "水表") &&
          (key == "进水温度传感器" || key == "出水温度传感器")
        ) {
        } else if (stateArray[key] == that.stateContrast[key]) {
          stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
        }
      });

      return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
    },
    changeColumn(checked, name) {
      if (checked) {
        this.showColumnTitleArray.push(name);
      } else {
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName + localStorage.getItem("userAccount"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;
    },
    showPage() {
      var that = this;
      that.data = [];
      that.$axios
        .post("/api/meterdetailed/selectMeterState", that.searchObject)
        .then(function(res) {
          console.log(res);

          that.data = res.body;
          that.data.map(item => {
            item.上报时间 =
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(item.messageTimestamp)
              ) == "NaN-aN-aN aN:aN:aN"
                ? ""
                : global.dateFtt(
                    "yyyy-MM-dd hh:mm:ss",
                    new Date(item.messageTimestamp)
                  );
            let messageContentObject = JSON.parse(item.messageContent);
            let paramArray = messageContentObject.decode?(messageContentObject.decode.paramArray?messageContentObject.decode.paramArray:{}):{};
            item.上报总次数 = paramArray.上传总次数
              ? paramArray.上传总次数.value + "次"
              : "";
            item.上报成功次数 = paramArray.上传成功次数
              ? paramArray.上传成功次数.value + "次"
              : "";
            item.抄表总次数 = paramArray.抄表总次数
              ? paramArray.抄表总次数.value + "次"
              : "";
            item.抄表成功次数 = paramArray.抄表成功次数
              ? paramArray.抄表成功次数.value + "次"
              : "";
            item.电池电压 = paramArray.电池电压
              ? paramArray.电池电压.value + paramArray.电池电压.unit
              : "";
            item.信号强度 = paramArray.信号强度
              ? paramArray.信号强度.value + paramArray.信号强度.unit
              : "";
            item.设备状态 = that.showStateStr(item);
            item.通信数据 =
              item.messageContent == undefined
                ? "无"
                : messageContentObject.data;
            return item;
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async getMeterArray() {
      var that = this;
      that.$axios
        .post("/api/meter/selectMeterList", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterArray = data.body;

          // that.showPage();
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    }
  },
  mounted() {
    // this.showPage();
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.8;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.8;

    this.generateColumnTitleArray();
    that.getMeterCaliberEnum();
    that.getMeterArray();
    that.getUserList();
    that.getAddressEnum();
    that.$axios
    .post("/api/meterdetailed/getMeterBirthList", that.searchObject)
    .then(function(res) {
        that.dateArray = res.body;
    })
    .catch(function(error) {
        console.log(error);
    });
  }
};
</script>

<style scoped>
</style>
